<div class="flex flex-col notifications-list">
  
  <app-sidenav-header [title]="title"></app-sidenav-header>

  <ng-container *ngIf="notifications.length > 0; else showNoNotificationsLabel">
    <div class="flex flex-row flex-auto justify-between items-center w-100-percent">
      <div class="clear-all mat-small fw-700 mb-16 cursor-pointer ml-auto mr-8" (click)="openClearAllModal()">
        {{'NOTIFICATIONS.CLEAR_ALL' | transloco}}
      </div>
    </div>
    <app-notification-card class="mb-16" [ngClass]="{'cursor-pointer': !notification.state.read}" *ngFor="let notification of notifications; let i = index" 
      [notification]="notification" (cleared)="onClearNotification($event, i)"  (click)="markAsRead(notification)"></app-notification-card>
  </ng-container>

  <ng-template #showNoNotificationsLabel>
    {{'NOTIFICATIONS.NO_NOTIFICATIONS' | transloco}}
  </ng-template>

  <span class="flex-auto"></span>
</div>
